export enum Mode {
  VIEW,
  ADD,
  EDIT
}
